import { useEffect, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button } from "react-bootstrap";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";

import InterCompany from "../../../../lib/json/consultas/InterCompany.json"
import SelectEmpresa from "../../../components/Select/Empresa";
import { ErroMsg, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../components/BootBox";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";

function ListaInterCompany(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = InterCompany.tabelas;
    
    const navigate = useNavigate();
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("InterCompanyEmpresa", {value: "",text: "", });

    // Colunas do grid
    const columns = [
        {
            Header: 'Id',
            accessor: "PZ3_ID",
        },
        {
            Header: 'Empresa',
            accessor: "PZ3_EMPRES",
            Cell: (item) => { return item.value + ' - ' + item.row.original.NOMEINTER}
        },
        {
            Header: 'Contas Contábeis',
            accessor: "PZ3_CONTCR",
            Cell: (item) => { 
                const { CREDITO, PZ3_CONTDE, DEBITO} = item.row.original
                return (
                    <>
                        <p><strong>Crédito: </strong> {item.value + ' - ' + CREDITO}</p>
                        <p><strong>Débito: </strong> {PZ3_CONTDE + ' - ' + DEBITO}</p>
                    </>
                )
            }
        },
    ];

    // Processa consulta do grid
    const listaInterCompany = async () => {
        var consultaDefault = InterCompany.consulta;
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, tabelasDefault, empresaFilial );
        
        if (retConsulta){
            setData(retConsulta.data);
        } 

        setCarregar(false);
    }

    useEffect( () => {
        listaInterCompany()
    },[])

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.PZ3_ID}/${row.original.EMPRESA}${row.original.M0_CODFIL}`)
    }
    
    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.values.PZ3_ID}/${row.original.EMPRESA}${row.original.M0_CODFIL}`)
    }
    
     const handleExcluir = async (row) => {
        const idRow = row.original.EMPRESA + '' + row.original.M0_CODFIL + '|' + row.original.PZ3_ID;
        const Mensagem = `Tem certeza que deseja excluir o InterCompany ${row.original.PZ3_ID}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { 
            ACAO: 'EXCLUIR',
            PZ3_ID: row.split('|')[1] 
        }
        
        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('INTERCOMPANY', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
            listaInterCompany();
        }
    };

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Empresas x Conta Contábil"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>                
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaInterCompany}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote" }, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger" }
                        ]}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaInterCompany;